import { api } from '@forbiz/web-kit'
import type { PhotoListResponse, PhotoUploadResponse } from '@forbiz/contracts'

/**
 * 배송 사진 API 클라이언트 (BIZ-13).
 *
 * 조회·업로드 모두 web-kit의 api 헬퍼를 쓴다. 업로드는 multipart라 api.upload로
 * 보내되(에러·401 세션만료 처리를 조회와 동일하게 공유), content-type은 브라우저가
 * boundary 포함해 자동 설정한다.
 */

export const photosApi = {
  /** 주문 사진 목록. 서명 URL만 담긴다(범위는 서버가 건다). */
  list: (orderId: number) => api.get<PhotoListResponse>(`/api/orders/${orderId}/photos`),

  /** 배송 사진 업로드(업체·배송 단계). 필드명은 file. */
  upload(orderId: number, file: File): Promise<PhotoUploadResponse> {
    const formData = new FormData()
    formData.append('file', file)
    return api.upload<PhotoUploadResponse>(`/api/orders/${orderId}/photos`, formData)
  },

  /** 배송 사진 삭제(업체·배송 단계). 잘못 올린 사진 제거. */
  delete: (orderId: number, photoId: number) =>
    api.del<void>(`/api/orders/${orderId}/photos/${photoId}`),
}
